import React from 'react';
import { reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Grid } from 'react-virtualized';

import config from '../../config';
import '../../styles/components/DayList.css';
import GridItem from './GridItem';
import ShiftModal from './ShiftModal';
import NewItemModal from './NewItemModal';
import EmployeePreview from '../EmployeeBar/EmployeePreview';
import DayModal from '../DayModal/DayModal';

export default inject('planStore', 'filterStore', 'employeeStore', 'shiftStore')(
  observer(class GridList extends React.Component {
    constructor() {
      super();

      this.gridRef = React.createRef();
    }

    componentDidMount() {
      /**
       * Reaction responds to changes in the store marked by the first method.
       * If the item in the first method changes, the second method is called with the value
       */
      reaction(
        () => this.props.planStore.lastUpdated,
        () => {
          this.gridRef.current.forceUpdate();
        }
      );

      reaction(
        () => this.props.planStore.skipToColumn,
        (skipToColumn) => {
          this.gridRef.current.scrollToPosition({ scrollLeft: skipToColumn * 250 });
        }
      );
    }

    render() {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      const rem = 10;

      return (
        <div className='daylist'>
          <Grid
            cellRenderer={obj => <GridItem {...obj} />}
            width={windowWidth - (31 * rem)}
            height={windowHeight - (3.75 * rem)}
            rowCount={1}
            rowHeight={windowHeight - (3.75 * rem)}
            columnCount={config.dateLookForward}
            columnWidth={250}
            overscanColumnCount={5}
            scrollToColumn={14}
            ref={this.gridRef}
          />

          <DayModal />
          <ShiftModal />
          <NewItemModal />
          <EmployeePreview key="__preview" name="group" />
        </div>
      );
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/Grid/index.js